<template>
  <v-row v-if="total > 1">
    <v-col>
      <v-pagination
        v-model="internalPage"
        :length="total"
        :total-visible="7"
        :disabled="loading"
        @input="onPageChange"
        navigation-color="grey"
        navigation-text-color="white"
        next-aria-label="next"
        color="var(--color-light-blue)"
      ></v-pagination>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    loading: Boolean,
    value: Number, // Use `value` for v-model binding
    total: Number,
  },
  data() {
    return {
      internalPage: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.internalPage = newValue;
    },
    internalPage(newPage) {
      this.$emit("input", newPage);
    },
  },
  methods: {
    onPageChange(page) {
      this.$emit("input", page); // Emit `input` event
    },
  },
};
</script>
